export default "__VITE_ASSET__5clij2Gq__"